import { reducer as navReducer } from "./reducers";
import { FeatureConfiguration } from "../index";

export default function (config: FeatureConfiguration) {
    config.reducers.nav = navReducer;
}
